import Modal from '@webclient/components/modal';
import FormHeader from '@webclient/components/settings/components/form-header';
import StyledBox from '@webclient/components/settings/components/modal-wrapper/styles';
import { TAB_ITEMS } from '@webclient/components/settings/config';

import useAppSettingsModal from '@webclient/hooks/useAppSettingsModal';
import useQueryParams from '@webclient/hooks/useQueryParams';
import useResponsive from '@webclient/hooks/useResponsive';

import CloseIcon from '~icons/knowz-iconify/cross';

import { IconButton } from '@knowz/knowz-ui';
import { useTranslate } from '@tolgee/react';

export type Props = {
  children: React.ReactNode;
  tabs: React.ReactNode;
};

export const MAX_MODAL_HEIGHT = 300;
export const HEADER_HEIGHT = '72px';

export default function ModalWrapper({ children, tabs }: Props) {
  const { t } = useTranslate();
  const { getQueryParamByKey, removeQueryParamByKey } = useQueryParams();
  const isItDesktop = useResponsive('up', 'md');
  const { isAppSettingsModalOpen, toggleAppSettingsModal } =
    useAppSettingsModal();

  const configQueryParam = getQueryParamByKey<string | null>('config');
  const isAppSettingsUrl = TAB_ITEMS.some(
    (item) => item.routeAlias === configQueryParam,
  );

  return (
    <Modal
      width={{
        xs: '100%',
        md: 900,
      }}
      height={{
        xs: '100%',
      }}
      open={isAppSettingsModalOpen || isAppSettingsUrl}
      onClose={() => {
        isAppSettingsUrl && removeQueryParamByKey('config');
        isAppSettingsModalOpen && toggleAppSettingsModal();
      }}
      sx={{
        maxHeight: {
          xs: '100%',
          md: 600,
        },
        borderRadius: {
          xs: 0,
          md: 3,
        },
      }}
    >
      <StyledBox>
        <FormHeader
          title={t(
            'layout.main.sections.header.navigation.settings',
            'Settings',
          )}
        >
          {!isItDesktop && (
            <IconButton
              color="secondary"
              variant="ghost"
              onClick={() => {
                isAppSettingsUrl && removeQueryParamByKey('config');
                isAppSettingsModalOpen && toggleAppSettingsModal();
              }}
            >
              <CloseIcon />
            </IconButton>
          )}
        </FormHeader>
        {tabs}
      </StyledBox>
      {children}
    </Modal>
  );
}
